import { format } from "date-fns";
import { useEffect } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import TextArea from "../../../../ui/molecules/textArea";
import { GetByIdPersonalManagement } from "../../slice";
import { RequirementDetailCreation, RequirementDetailValidation, resetRequirementDetailCreationRequest, resetRequirementDetailCreationStatus, resetRequirementDetailErrors, resetRequirementDetails, resetRequirementDetailValidationStatus, setReqDetailDetail, setReqDetailEnding, setReqDetailNote, setReqDetailProtocols, setReqDetailStarting } from "../slice";

interface Props {
    close: () => void
}

export function RequirementDetailPopupAdd(props: Props) {
    const dispatch = useAppDispatch()
    const requirementState = useAppSelector(state => state.PMRequirement)
    const PMState = useAppSelector(state => state.personalManagement)

    useEffect(() => {
        if (requirementState.requirementDetailValidationStatus === 'successfully') {
            dispatch(resetRequirementDetailValidationStatus())
            dispatch(resetRequirementDetailErrors())
            dispatch(RequirementDetailCreation(requirementState.requirementDetailCreationRequest))
        }
    }, [requirementState.requirementDetailValidationStatus])

    useEffect(() => {
        if (requirementState.requirementDetailCreationStatus === 'successfully') {
            dispatch(resetRequirementDetailCreationStatus())
            dispatch(resetRequirementDetailCreationRequest())
            dispatch(resetRequirementDetails())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [requirementState.requirementDetailCreationStatus])

    return (
        <Fragment>
            <div className="bg-white p-6 flex flex-col gap-6">
                <div className="grid grid-cols-2 gap-6">
                    <Calendar
                        label="Dal"
                        selected={requirementState.requirementDetailCreationRequest.starting}
                        onChange={(date) => {
                            dispatch(setReqDetailStarting(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                    <Calendar
                        label="Al"
                        selected={requirementState.requirementDetailCreationRequest.ending}
                        onClear={(date) => dispatch(setReqDetailEnding(date))}
                        onChange={(date) => {
                            dispatch(setReqDetailEnding(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                </div>
                <TextArea
                    label="Dettagli requisito"
                    placeholder="Descrivi i dettagli del requisito"
                    value={requirementState.requirementDetailCreationRequest.detail}
                    defaultValue={requirementState.requirementDetailCreationRequest.detail}
                    error={requirementState.requirementDetailErrors.detail}
                    supportingText={requirementState.requirementDetailErrors.detail ? 'Dettagli mancanti!' : undefined}
                    onChangeText={(text) => dispatch(setReqDetailDetail(text))} />

                <TextArea
                    label="Specifiche protocollo"
                    placeholder="Specificare Sede, Data e Numero di Protocollo..."
                    value={requirementState.requirementDetailCreationRequest.protocols}
                    defaultValue={requirementState.requirementDetailCreationRequest.protocols}
                    error={requirementState.requirementDetailErrors.protocols}
                    supportingText={requirementState.requirementDetailErrors.protocols ? 'Dettagli mancanti!' : undefined}
                    onChangeText={(text) => dispatch(setReqDetailProtocols(text))} />

                <TextArea
                    label="Note"
                    value={requirementState.requirementDetailCreationRequest.note}
                    defaultValue={requirementState.requirementDetailCreationRequest.note}
                    onChangeText={(text) => dispatch(setReqDetailNote(text))} />
            </div>
            <div className="flex justify-end gap-2 border-t border-neutral-200 px-6 py-4 bg-neutral-50">
                <ButtonComponent
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="gray"
                    onClick={() => {
                        dispatch(resetRequirementDetailCreationRequest())
                        dispatch(resetRequirementDetailErrors())
                        props.close();
                    }}
                />
                <ButtonComponent
                    size="md"
                    variant="solid"
                    iconPosition="off"
                    label="Salva"
                    color="orange"
                    onClick={() => {
                        dispatch(RequirementDetailValidation(requirementState.requirementDetailCreationRequest))
                    }}
                />
            </div>
        </Fragment>
    )
}